import type { StatsResponse, Timeseries } from '~/api/types'
import { StatCard } from '~/components/StatCard'
import { Skeleton } from '~/components/ui/skeleton'
import { formatPeriodLabel, type View } from '~/components/dashboard/constants'

// 2) 핵심 KPI 행 — 통계/시계열 보기에 따라 후반 3장이 달라진다.
export function KpiSection({
    loading,
    view,
    stats,
    timeseries,
    days,
}: {
    loading: boolean
    view: View
    stats: StatsResponse | null
    timeseries: Timeseries | null
    days: number
}) {
    const periodLabel = formatPeriodLabel(days)
    const sat = stats?.satisfaction
    const satRate = sat && sat.total > 0 ? sat.upRate : 0
    const satEmpty = !sat || sat.total === 0

    return loading ? (
        <div className='grid grid-cols-2 gap-4 lg:grid-cols-3 xl:grid-cols-6'>
            {Array.from({ length: 6 }).map((_, i) => (
                <Skeleton key={i} className='h-[92px]' />
            ))}
        </div>
    ) : (
        <div className='grid grid-cols-2 gap-4 lg:grid-cols-3 xl:grid-cols-6'>
            <StatCard
                label='활성 사용자'
                value={timeseries?.activeUsers ?? '-'}
                hint={`최근 ${periodLabel} 활동`}
                tone='primary'
            />
            <StatCard
                label='신규 사용자'
                value={timeseries?.newUsers ?? '-'}
                hint={`최근 ${periodLabel} 가입`}
                tone='success'
            />
            <StatCard
                label='전체 사용자'
                value={stats?.users.total ?? '-'}
                hint={`관리자 ${stats?.users.admins ?? '-'}명`}
            />
            {view === 'stats' ? (
                <>
                    <StatCard
                        label='상담 세션'
                        value={stats?.consultation.sessions ?? '-'}
                        hint={`최근 7일 ${stats?.consultation.sessions7d ?? '-'}건`}
                    />
                    <StatCard
                        label='인증평가'
                        value={stats?.certification.total ?? '-'}
                        hint={`최근 7일 ${stats?.certification.total7d ?? '-'}건`}
                    />
                    <StatCard
                        label='👍 만족도'
                        value={
                            satEmpty ? '-' : `${Math.round(satRate * 100)}%`
                        }
                        hint={`전체 ${sat?.total ?? '-'}건`}
                    />
                </>
            ) : (
                <>
                    <StatCard
                        label='총 활동(트래픽)'
                        value={timeseries?.totalEvents ?? '-'}
                        hint={`최근 ${periodLabel} 이벤트 합`}
                        tone='info'
                    />
                    <StatCard
                        label='미확인 알림'
                        value={stats?.monitoring.alertsUnread ?? '-'}
                        hint={`전체 ${stats?.monitoring.alertsTotal ?? '-'}건`}
                        tone='warning'
                    />
                    <StatCard
                        label='기간'
                        value={periodLabel}
                        hint={
                            timeseries
                                ? `${timeseries.fromDate} ~ ${timeseries.toDate}`
                                : '-'
                        }
                    />
                </>
            )}
        </div>
    )
}
